var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Card",
    { attrs: { "dis-hover": true } },
    [_c("BinFenSeedFarmUserList")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }